import { WORKFLOW_ACTIONS } from 'modules/workflows/constants';
import styled from 'styled-components';
import { RadioList } from 'ui/radioList';
import { Row, TopText } from 'ui/radioList/RadioListStyles';
import { Label, spacing } from 'ui/theme';

export const StyledRadioList = styled(RadioList)`
  ${Row} {
    margin-bottom: 0;
  }
  ${TopText} {
    margin-top: 3px;
  } ;
`;

export const StyledFormLabel = styled(Label)`
  margin-bottom: ${spacing.half};
`;

const UPDATE_CONTACT_OPTIONS = {
  [WORKFLOW_ACTIONS.CHANGE_CONTACT_FIELD]: {
    id: 'Data fields',
    value: WORKFLOW_ACTIONS.CHANGE_CONTACT_FIELD,
    name: 'Use the data below',
  },
  [WORKFLOW_ACTIONS.UPDATE_CONTACT_WEBHOOK]: {
    id: 'Webhook',
    value: WORKFLOW_ACTIONS.UPDATE_CONTACT_WEBHOOK,
    name: 'Retrieve data from a webhook',
  },
};

export const RADIO_OPTIONS = Object.values(UPDATE_CONTACT_OPTIONS);

type UpdateUserActionsProps = {
  updateAction: string;
  setUpdateAction: (val: string) => void;
  isReadOnly: boolean;
};

export const UpdateUserActions = ({
  updateAction,
  setUpdateAction,
  isReadOnly,
}: UpdateUserActionsProps) => {
  return (
    <>
      <StyledFormLabel>How do you want to make user profile updates?</StyledFormLabel>
      <StyledRadioList
        name="set-sub-action"
        onSelect={setUpdateAction}
        options={RADIO_OPTIONS}
        isReadOnly={isReadOnly}
        value={UPDATE_CONTACT_OPTIONS[updateAction]?.value}
      />
    </>
  );
};
